import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { type Course } from './Course.tsx'
import { appelerApi, verifier, CLE_TABLE_COURSES } from './api.ts'

// Modification d'une course ajoutee par l'utilisateur (PUT /api/events/{id}).
export default function useUpdateCourse() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (course: Course) => {
      await verifier(await appelerApi('/api/events/' + encodeURIComponent(course.id_calendrier), 'PUT', course), [204]);
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: CLE_TABLE_COURSES }),
  });
}
